export enum VitalSignsKeys {
  TEMP = 'TEMP',
  SPO2 = 'SPO2',
  INV_D_BP = 'INV_D_BP',
  INV_S_BP = 'INV_S_BP',
  INV_M_BP = 'INV_M_BP',
  NON_INV_S_BP = 'NON_INV_S_BP',
  NON_INV_D_BP = 'NON_INV_D_BP',
  NON_INV_M_BP = 'NON_INV_M_BP',
  RR = 'RR',
  HEART_RATE = 'HEART_RATE',
  PULSE_RATE = 'PULSE_RATE',
  PATIENT_NAME = 'PATIENT_NAME',
  LAC = 'LAC',
  K = 'K',
  GFR = 'GFR',
  PH = 'PH',
  THB = 'THB',
  PCO2 = 'PCO2',
  LACTATE = 'LACTATE',
  CREATININE = 'CREA',
  URINE = 'HARN'
}
